import { render, staticRenderFns } from "./RespectOutline.vue?vue&type=template&id=54fb7d20&"
import script from "./RespectOutline.vue?vue&type=script&lang=ts&"
export * from "./RespectOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports